/** Resources whose written-out name is not simply their key capitalised. `mail` is the person's own mailbox (#883). */
const RESOURCE_LABELS: Record<string, string> = { llm: 'LLM', mail: 'Your mail' }

/**
 * A base resource's name in words: `tasks` reads as `Tasks`, and anything named in `RESOURCE_LABELS` reads
 * as written there instead (`llm` as `LLM`). Shared by every screen that lists resources by name, so they
 * cannot drift into two different ideas of what one resource is called.
 */
export function resourceLabel(resource: string): string {
    return RESOURCE_LABELS[resource] ?? resource.charAt(0).toUpperCase() + resource.slice(1)
}
